/**
 * Centralized listing status configuration.
 * Single source of truth for status labels, colors, and backgrounds.
 */
export const STATUS_CONFIG = {
    FOR_SALE: { label: 'For Sale', color: '#059669', bg: '#ecfdf5' },
    FOR_RENT: { label: 'For Rent', color: '#2563eb', bg: '#eff6ff' },
    SOLD: { label: 'Sold', color: '#dc2626', bg: '#fef2f2' },
    PENDING: { label: 'Pending', color: '#7c3aed', bg: '#f5f3ff' },
    OFF_MARKET: { label: 'Off Market', color: '#d97706', bg: '#fffbeb' },
    NEW_COMMUNITY: { label: 'New Community', color: '#0891b2', bg: '#ecfeff' },
    READY_TO_BUILD: { label: 'Ready to Build', color: '#16a34a', bg: '#f0fdf4' },
    OTHER: { label: 'Other', color: '#6b7280', bg: '#f9fafb' },
    UNKNOWN: { label: 'Unknown', color: '#6b7280', bg: '#f9fafb' },
};

/**
 * Helper to get status config with safe fallback.
 */
export const getStatusConfig = (status) =>
    STATUS_CONFIG[status] || STATUS_CONFIG.UNKNOWN;
